import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order?: { customer?: { name?: string } };
};

const CustomerCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.order?.customer && (
      <Tooltip title={row?.order?.customer?.name ?? ''}>
        <Typography variant="body2" noWrap>
          {row?.order?.customer?.name}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default CustomerCell;
